import React from "react";
import { Stack, Text, Box, Flex } from "@mantine/core";
import { SegmentedScale } from "../../../components/form/SegmentedScale";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const options = [
    "Totalmente de acuerdo.",
    "De acuerdo.",
    "En desacuerdo.",
    "Totalmente en desacuerdo.",
  ];

  const questions = [
    "Si denuncio un caso de acoso me podría generar consecuencias en mi organización.",
    "Un caso de acoso en el que se acusa a una persona que pertenece a la plana gerencial no sería investigado adecuadamente en mi trabajo.",
    "El acoso no es tolerado en mi organización.",
    "Las personas que acosan a otras/os normalmente se salen con la suya (por ejemplo, no son sancionadas).",
    "Mi organización está tomando acciones efectivas contra el acoso.",
    "Las personas que ocupan cargos directivos en mi organización tienen una postura expresa contra el acoso.",
  ];

  const questionIds = [
    "CON_001",
    "CON_003",
    "CON_004",
    "CON_005",
    "CON_006",
    "CON_007",
  ];
  // Combine questions with their corresponding IDs
  const questionsWithIds = questions.map((question, index) => ({
    question,
    id: questionIds[index],
  }));

  const handleScaleClick = (questionId: string, optionValue: string) => {
    form.setFieldValue(questionId, optionValue);
  };

  return (
    <Box px="sm">
      <Stack spacing="lg">
        <Text fw={500} size="sm" color="gray.8">
          ¿Qué tan de acuerdo estas con las siguientes afirmaciones?
        </Text>
        {/* Leyenda */}
        <Box
          p="md"
          bg="transparent"
          style={{
            borderRadius: 8,
            border: "1px solid #e9ecef",
          }}
          mb="xl"
        >
          <Text fw={400} mb="sm" color="gray.8">
            Leyenda
          </Text>
          <Flex wrap="wrap" gap="lg" justify="space-between">
            <Text size="sm" color="gray.7">
              <strong>1</strong> = Totalmente de acuerdo
            </Text>
            <Text size="sm" color="gray.7">
              <strong>2</strong> = De acuerdo
            </Text>
            <Text size="sm" color="gray.7">
              <strong>3</strong> = En desacuerdo
            </Text>
            <Text size="sm" color="gray.7">
              <strong>4</strong> = Totalmente en desacuerdo
            </Text>
          </Flex>
        </Box>

        <Stack spacing="xl">
          {questionsWithIds.map(({ question, id }) => (
            <Box key={id}>
              <Text size="sm" mb="md" style={{ textAlign: "justify" }}>
                {question}
              </Text>
              {form.errors[id] && (
                <Text fz="xs" color="red" mb="sm">
                  *Debes seleccionar una opción.
                </Text>
              )}
              <SegmentedScale
                value={form.values[id] || ""}
                onChange={(value) => handleScaleClick(id, value)}
                segments={options}
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default Component;
